var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vdp-legend",style:({
            'height': this.computedHeight + 'px', 
            'width': this.computedWidth + 'px',
            'top': this.computedTop + 'px',
            'left': this.computedLeft + 'px'
        }),attrs:{"id":this.legendElemID}}),(_vm.showColorScalePicker)?_c('ColorScalePicker',{attrs:{"onSelect":_vm.changeColorScale},on:{"close":function($event){_vm.showColorScalePicker = false}}}):_vm._e(),(_vm.showColorPicker)?_c('ColorPicker',{attrs:{"onSelect":_vm.changeColor,"initialColor":_vm.initialColor},on:{"close":function($event){_vm.showColorPicker = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }